'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = require('./common');

exports.default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/validators/alphaNum.js
// module id = 1119
// module chunks = 1